import { ButtonV1 } from "lib";
import { Row, Container } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { dynamicFormScroll } from "utils";
import Table from "react-bootstrap/Table";
import DynamicForm from "components/DynamicForm";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "components/DynamicForm/validate";
import { uniqueWorkFlowId } from "helper/uniqueWorkFlowId";
import React, { Fragment, useEffect, useState } from "react";
import { createBulkPrimaryWorkFlows } from "api/formDisplay";
import { createMasterDataPayload } from "helper/createPayload";
import { clearSelectedData, setSelectedData } from "redux/formDisplay";
import { handleEmailNotification, sendSMSInvite } from "helper/callbacks";
import { setcsvBulkresponse } from "redux/dashboardReducer";
import { handleEmailBulkNotification } from "helper/callbacks";
import { terminateOrRevokeApplication } from "api/dashboardDetail";

import FormButton from "components/FormButton";
import { encryptUrl } from "api/UrlEncryption";

const ResponsiveModal = (props) => {
  const { selectedOption, closeModal } = props;

  const [show, setShow] = useState(true);
  const [formErr, setFormErr] = useState({});
  const [records, setRecords] = useState([]);
  const [button, setButton] = useState("Invite");
  const [successModal, setsuccessModal] = useState(false);
  const [manualInvite, setmanualInvite] = useState(false);
  const [dashboardForm, setDashboardForm] = useState([]);
  const [successMessage, setsuccessMessage] = useState("")
  const [encryptedListingID, setEncryptedID] = useState(null);
  const [disableInvite,setDisableInvite] = useState(false)

  const { dashboardConfig, csvBulkresponse } = useSelector(
    (state) => state.dashboardReducer
  );
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const bulk = useSelector((state) => state.formData?.bulkaddCustomer);
  const activeStepOrder = useSelector(
    (state) => state.conditionalRendering?.activeStepOrder
  );
  const WorkflowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.workFlowInfo
  );
  const userSubworkFlowInfo = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  );

  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const isMobileVerified = useSelector(
    (state) => state.otpReducer?.isMobileVerified
  );
  const isEmailVerified = useSelector(
    (state) => state.otpReducer?.isEmailVerified
  );
  const staticData = useSelector((state) => state.staticData);
  const organisationInfo = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo
  );
  const organisationIdOfUser = useSelector(
    (state) =>
      state?.loggedInUserInfo?.userAuthInfo?.profileInfo?.organisationId
  );
  const arrayName = useSelector(
    (state) => state?.formData?.bulkaddCustomer?.arrayName
  );

  useEffect(() => {
    if (manualInvite) 
      setDashboardForm([...dashboardConfig?.invite_manual_form?.form_elements]);
  }, [manualInvite]);

  useEffect(() => {
    if (csvBulkresponse) {
      setsuccessModal(true);
      setsuccessMessage("Customers have been Invited Successfully")
    }
  }, [csvBulkresponse]);

  useEffect(() => {
    const fetchData = async () => {
        if (dashboardConfig) {
            const encryptedData =  await encryptUrl(dashboardConfig._id);
            setEncryptedID(encryptedData);
        } else {
            console.error("dashboardConfig is undefined");
        }
    };
    fetchData();
}, [dashboardConfig]);

const getDynamicDescriptionValue = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    throw new Error("Input must be a valid object");
  }
  for (const key of Object.keys(obj)) {
    if (key.endsWith('_description')) {
      return obj[key];
    }
  }
};


const handleBulkUpload = async () => {
  try {
    const BulkId = getDynamicDescriptionValue(selectedData);
    const encryptedID = await encryptUrl(BulkId);
    window.location.href = `${selectedOption?.routing_link}/${encryptedListingID}/${encryptedID}`;
  } catch (error) {
    console.error("Error in handleBulkUpload:", error);
  }
}




  const handleTerminate = async (param) =>{
    let params = {
      primaryWorkflowId : WorkflowInfo?.primary_workflow_id || userSubworkFlowInfo?.primary_workflow_id,
      configuration_id : WorkflowInfo?.configuration_id,
      organisation_id : WorkflowInfo?.organisation_id,
      loggedInUserId : loggedInUserInfo?.profileInfo['userId'],
      ...param
    }
    let res =  await terminateOrRevokeApplication(params)
    closeModal()
    window.location.reload()
  }


  const dispatch = useDispatch();
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");
  const organisation_id = dashboardConfig?.organisation_id;

  let link = window.location.href;
  let splitUrl = link.split("/");
  splitUrl.splice(4, 1);
  link = splitUrl.join("/");
   let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let loggedInUserName = loggedUserId
    ? `${
        (loggedInUserInfo?.profileInfo?.first_name || "") +
        " " +
        (loggedInUserInfo?.profileInfo?.last_name || "")
      }`
    : "";
  let loggedInUserEmail =
    loggedUserId && loggedInUserInfo?.profileInfo?.emailId;
  let loggedInUserMobileNumber =
    loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber;

  const handleClose = () => {
    setsuccessModal(false);
    closeModal();
    dispatch(clearSelectedData());
  };
  const handlesuccessModalClose = () => {
    setsuccessModal(false);
    setShow(false);
    dispatch(clearSelectedData());
    closeModal();
    if (csvBulkresponse) {
      dispatch(setcsvBulkresponse(false));
    }
  };

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const sendInvite = async () => {
    setButton("Inviting...");
    let userdata = records;
    let params = {
      organisation_id: organisationIdOfUser,
      trigger: "inviteCustomer",
      link: `${link}/${dashboardConfig?.invite_customer}`,
      hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
      userdata,
    };
    let resp = await handleEmailBulkNotification(params);
    if (resp[0]?.status == "success") {
      setsuccessModal(true);
      setsuccessMessage(selectedOption?.success_message)
      setButton("Invite");
    } else setButton("Invite");
    setRecords([]);
    setmanualInvite(false);
    dispatch(clearSelectedData());
  };

  const sendSingleInvite = async () => {
    setButton("Sending...");
    setDisableInvite(true);
    let params = {
      organisation_id: organisationIdOfUser,
      to: selectedData?.email,
      trigger: "inviteCustomer",
      recipientName: selectedData?.name,
      link: `${link}/${dashboardConfig?.invite_customer}`,
      // has_link_expiry: organisationInfo?.has_link_expiry,
      hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
    };
    let response ;
    if (selectedData?.mobile_number) {
      let mobile = selectedData?.mobile_number.split("-");
      let smsParams = {
        mobile_number: mobile[1],
        link: `${link}/${dashboardConfig?.invite_customer}`,
        organisation_id: organisationIdOfUser,
        // has_link_expiry: organisationInfo?.has_link_expiry,
        hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
      };
      response = await sendSMSInvite(smsParams);
    }
    let resp = await handleEmailNotification(params);
    if (resp?.status.toLowerCase() == "success" || response ?.status.toLowerCase() == "success" ) {
      setDisableInvite(false);
      setsuccessModal(true);
      setTimeout(() => {
        handlesuccessModalClose();
      }, 2000);
      setsuccessMessage(selectedOption?.success_message)
    }
  };

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };
    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };

  const deleteRecord = (index) => {
    const updatedRecords = [...records];
    updatedRecords.splice(index, 1);
    setRecords(updatedRecords);
  };

  const handleFormValidation =async (fields, successCallback) => {
    let FormFields
    if(manualInvite){
      FormFields=dashboardForm
    }else{
      FormFields=fields
    }
    const validateFields = FormFields.filter(field => {
      const isVisible = FormFields.show ? IndirectEval(field.show) : true;
      return isVisible;
    }); 
    const errors =await  validate(validateFields, selectedData, dispatch, staticData);
    if (Object.keys(errors).length === 0) {
      if(manualInvite){
          let newData={name:selectedData?.name,email: selectedData?.email}
          setRecords([...records, newData]);
          dispatch(clearSelectedData());
      }else{
        successCallback();
      }
    } else {
      setFormErr(errors);
      dynamicFormScroll();
    }
  };
  
  const handleValidateData = () => {
    selectedOption.form_buttons.forEach(item => {
      if (item?.label?.includes("Invite Customer")) {
        handleFormValidation(selectedOption.form_elements, sendSingleInvite);
      } else if (item?.label?.includes("Invite Bulk Customer")) {
        handleFormValidation(selectedOption?.form_elements, () => setmanualInvite(true));
      } else if (item?.label?.includes("Add Bulk Customer")) {
        try {
          const payloadArray = bulk?.validUserData;
          const finalPayloadArray = [];
          for (let record of payloadArray) {
            let order = activeStepOrder;
            let sourceDataFields = bulk?.sourceData_fields;
            const deletedFields = {};
            if (Array.isArray(sourceDataFields)) {
              for (const fieldObj of sourceDataFields) {
                const fieldName = fieldObj?.id;
                if (
                  record &&
                  typeof record === "object" &&
                  record.hasOwnProperty(fieldName)
                ) {
                  deletedFields[fieldName] = record[fieldName];
                  record = Object.fromEntries(
                    Object.entries(record).filter(([key]) => key !== fieldName)
                  );
                }
              }
            }
            let saveData = [];
            saveData?.push(record);
            let applicant_sequence = bulk?.application_sequence;
            const dynamicConfigId = dashboardConfig?.wf_configuration_id;
            const configurationId = dashboardConfig?.wf_configuration_id;
            let uniqueName = bulk?.application_sequence
              ? bulk?.application_sequence
              : bulk?.wf_name;
            let application_ref_id = uniqueWorkFlowId(uniqueName);
            let recursiveData = {};
            let finalPayload = createMasterDataPayload(
              null,
              deletedFields,
              organisation_id,
              configurationId,
              saveData,
              isEmailVerified,
              isMobileVerified,
              null,
              null,
              null,
              order,
              dynamicConfigId,
              application_ref_id,
              loggedUserId,
              applicant_sequence,
              loggedInUserName,
              loggedInUserEmail,
              loggedInUserMobileNumber,
              recursiveData,
              null,
              null,
              null,
              null
            );
            if (!sourceDataFields) {
              finalPayload.source_data.max_active_group = 2;
              finalPayload.source_data.max_active_section = 1;
              finalPayload.source_data.active_section = 1;
              finalPayload.source_data.active_group = 2;
              finalPayload.source_data[arrayName] = saveData;
            }
            finalPayload.verification = !!queryPath; // Set verification based on queryPath
            finalPayloadArray.push(finalPayload);
          }
          dispatch(createBulkPrimaryWorkFlows(finalPayloadArray));
          setsuccessModal(true);
          setsuccessMessage(selectedOption?.success_message);
        } catch (error) {
          console.error("Error processing bulk data:", error); // Enhanced error logging
        }
      }
    });
  };
  

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size={`${manualInvite ? "lg" : ""}`}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {!manualInvite && !successModal ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title className="text-theme-primary fw-bold">
                {selectedOption && selectedOption?.label
                  ? selectedOption?.label
                  : "NA"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-0">
              <div className=".d-flex align-items-center">
                {!!selectedOption?.form_elements?.length &&
                  selectedOption?.form_elements?.map((item, index) => {
                    if (IndirectEval(item?.show)) {
                      return (
                        <Fragment key={index}>
                          <Row>
                            <DynamicForm
                              formFields={item}
                              formErr={formErr}
                              setFormErr={setFormErr}
                              selectedData={selectedData}
                              setSelectedData={setSelectedData}
                              clearFieldError={clearFieldError}
                            />
                          </Row>
                        </Fragment>
                      );
                    }
                  })}
              </div>
            </Modal.Body>
          </>
        ) : successModal ? (
          <Modal onHide={handlesuccessModalClose} centered show={successModal}>
            <Modal.Body className="p-5">
              <div className="align-items-center d-flex flex-column justify-content-center">
                <span className="mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="90.818"
                    height="90.818"
                    viewBox="0 0 90.818 90.818"
                  >
                    <g
                      id="Group_2010"
                      data-name="Group 2010"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_947"
                        data-name="Path 947"
                        d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z"
                        transform="translate(-82.261 -259.55)"
                        fill="#003975"
                        opacity="0.1"
                      />
                      <path
                        id="Path_948"
                        data-name="Path 948"
                        d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z"
                        transform="translate(-78.77 -256.057)"
                        fill="#003975"
                      />
                      <path
                        id="Path_949"
                        data-name="Path 949"
                        d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z"
                        transform="translate(-75.825 -251.948)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                </span>
                {successMessage &&
                <p>{successMessage}</p>
                }
                
              </div>
            </Modal.Body>
          </Modal>
        ) : (
          <>
            <Modal.Header className="pb-0 d-flex justify-content-between position-relative">
              <button
                className="btn btn-close top-0 end-0 mt-3 me-3 position-absolute "
                onClick={handleClose}
              ></button>
              <Modal.Title className="text-theme-primary fw-bold">
                {selectedOption?.label}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-0">
              <div>
                <div className="d-flex align-items-end justify-content-between mb-3">
                  <Container>
                    <Row>
                      {dashboardForm?.map(             
                        (item, index) => {
                          if (IndirectEval(item?.show)) {
                            return (
                              <Fragment key={index}>
                                <DynamicForm
                                  formFields={item}
                                  formErr={formErr}
                                  setFormErr={setFormErr}
                                  selectedData={selectedData}
                                  setSelectedData={setSelectedData}
                                  clearFieldError={clearFieldError}
                                />
                              </Fragment>
                            );
                          }
                        }
                      )}
                    </Row>
                  </Container>

                  <div className="mb-2">
                    <button className="btn border-0" onClick={handleFormValidation}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        class="bi bi-plus-circle-fill text-theme"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
                <Table bordered hover responsive className="theme-scrollbar">
                  <thead className="bg-theme-grey-1">
                    <tr>
                      <th>Sl No.</th>
                      <th>Name</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records?.map((record, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="min-w-150px">{record?.name}</td>
                        <td className="min-w-150px d-flex justify-content-between">
                          {record?.email}

                          <button
                            className="btn d-flex align-items-center justify-content-center border-0"
                            onClick={() => deleteRecord(index)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-dash-circle-fill text-danger"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z" />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
          </>
        )}
        <Modal.Footer>
        <div>
  {manualInvite ? (
    <>
      <ButtonV1
        label={button}
        className="primary_button"
        variant="primary"
        onClick={sendInvite}
        disabled={records?.length < 3 || records?.length > 7}
      />
    </>
  ) : (
    <>
      {disableInvite ? (
        <ButtonV1
          label={"Sending invitation.."}
          className="primary_button"
          variant="primary"
          disabled={true}
        />
      ) : (
        <FormButton
          selectedData={selectedData}
          formButtons={selectedOption?.form_buttons}
          handleTerminate={handleTerminate}
          handleValidateData={handleValidateData}
          handleBulkUpload={handleBulkUpload}
          className={selectedOption?.form_buttons?.custom_style}
        />
      )}
    </>
  )}
</div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResponsiveModal;
